import { createRouter, createWebHistory } from 'vue-router';

import Welcome from '@/pages/welcome.vue';
import Sports from '@/pages/sports.vue';
import Users from '@/pages/users.vue';
import Stakes from '@/pages/stakes.vue';
import Status from '@/pages/status.vue';
import Translations from '@/pages/translations.vue';
import CalculatorItem from '@/components/calculator/calculator-item.vue';
import PopularCompetitions from '@/pages/popular-competitions.vue';
import PopularFixtures from '@/pages/popular-fixtures.vue';
import InprogressFixtures from '@/pages/inprogress-fixtures.vue';
import Event from '@/pages/event.vue';
import Bets from '@/pages/bets.vue';
import Profile from '@/pages/profile.vue';
import Pools from '@/pages/pools.vue';
import Toto from '@/pages/toto.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: Welcome,
    },
    {
      path: '/status',
      name: 'status',
      component: Status,
    },
    // {
    //   path: '/calculator',
    //   name: 'calculator',
    //   component: Calculator,
    // },
    {
      path: '/calculator/:id/:stakeId?',
      name: 'calculator-item',
      component: CalculatorItem,
    },
    {
      path: '/stakes',
      name: 'stakes',
      component: Stakes,
    },
    {
      path: '/translations',
      name: 'translations',
      component: Translations,
    },
    {
      path: '/sports',
      name: 'sports',
      component: Sports,
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
    },
    {
      path: '/popular-competitions',
      name: 'popular-competitions',
      component: PopularCompetitions,
    },
    {
      path: '/popular-events',
      name: 'popular-events',
      component: PopularFixtures,
    },
    {
      path: '/in-progress-events',
      name: 'in-progress-events',
      component: InprogressFixtures,
    },
    {
      path: '/event/:id?',
      name: 'detailed-event',
      component: Event,
    },
    {
      path: '/bets',
      name: 'detailed-bets',
      component: Bets,
    },
    {
      path: '/profile/:id?',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/pools/:id?',
      name: 'pools',
      component: Pools,
    },
    {
      path: '/toto/:id?',
      name: 'toto',
      component: Toto,
    },
  ],
});

export default router;
